export const EditableField = ({ editing, view, edit }) => (editing ? edit : view);
